import type { Messages } from './en';

export const sv: Messages = {
  "language.label": "Språk",
  "auth.login": "Logga in",
  "auth.signup": "Skapa konto",
  "auth.signupTitle": "Skapa ditt konto",
  "auth.signupLead": "Skapa ditt konto, bekräfta din e-post, så kan din gratis provperiod starta direkt.",
  "auth.loginLead": "Logga in med din e-post eller användarnamnet vi skickade till dig.",
  "auth.passwordChanged": "Lösenordet är ändrat. Logga in med ditt nya lösenord.",
  "auth.name": "Ditt namn",
  "auth.email": "E-post",
  "auth.emailOrUsername": "E-post eller användarnamn",
  "auth.whatsapp": "WhatsApp-nummer",
  "auth.whatsappHint": "Så att vi kan nå dig på WhatsApp.",
  "auth.password": "Lösenord",
  "auth.keepLoggedIn": "Håll mig inloggad på den här enheten",
  "auth.wait": "Vänta…",
  "auth.forgot": "Glömt lösenordet?",
  "auth.enterName": "Skriv ditt namn.",
  "auth.weakPassword": "Välj ett starkare lösenord: det måste uppfylla alla punkter i listan under lösenordet.",
  "auth.deviceUnsupported": "Den här enheten stöds inte.",
  "auth.loginAgain": "Logga in igen.",
  "auth.accountDeleted": "Ditt konto har raderats.",
  "password.rules": "Krav på lösenordet",
  "password.length": "Minst 8 tecken",
  "password.upper": "En versal",
  "password.lower": "En gemen",
  "password.number": "En siffra",
  "password.done": "(klart)",
  "password.missing": "(saknas)",
  "phone.country": "Land: {name}, +{dial}",
  "phone.placeholder": "70 123 45 67",
  "phone.search": "Sök efter ditt land",
  "phone.countries": "Länder",
  "phone.noCountry": "Inget land hittades",
  "reset.title": "Återställ ditt lösenord",
  "reset.sent": "Om {email} har ett konto har vi skickat en 6-siffrig kod. Skriv in den tillsammans med ditt nya lösenord.",
  "reset.lead": "Skriv din e-post så skickar vi en kod.",
  "reset.code": "Kod",
  "reset.newPassword": "Nytt lösenord",
  "reset.save": "Spara nytt lösenord",
  "reset.send": "Skicka kod",
  "reset.back": "Tillbaka till inloggningen",
  "catalog.title": "Vilka språk tittar du på tv på?",
  "catalog.lead": "Dina kanaler, filmer och serier kommer på de här språken, så att appen laddar snabbt i mobilen och på tv:n.",
  "catalog.continue": "Fortsätt",
  "catalog.languages": "Språk",
  "catalog.more": "Fler språk…",
  "catalog.international": "Även internationella filmer och serier",
  "catalog.internationalHint": "(utan specifikt språk, t.ex. ”Netflix-filmer”: gör listan större)",
  "catalog.note": "Dagens matcher på Hem finns kvar på alla språk. Du kan ändra detta när som helst under Konto.",
  "catalog.saving": "Sparar…",
  "catalog.chooseOne": "Välj minst ett språk",
  "verify.title": "Bekräfta din e-post",
  "verify.lead": "Vi har skickat en 6-siffrig kod till {email}. Skriv in den nedan. Kolla skräpposten om du inte ser den.",
  "verify.code": "Kod",
  "verify.newCodeSent": "En ny kod är på väg.",
  "verify.checking": "Kontrollerar…",
  "verify.confirm": "Bekräfta",
  "verify.resend": "Skicka en ny kod",
  "noAccess.noPlan.title": "Starta din gratis provperiod",
  "noAccess.noPlan.body": "Begär din gratis provperiod och titta på allt på den här enheten. De flesta provperioder startar direkt; din tid börjar när du spelar upp något första gången.",
  "noAccess.noPlan.contact": "Hej, jag vill prenumerera på IPTViva.",
  "noAccess.pending.title": "Provperiod begärd",
  "noAccess.pending.body": "Vi har fått din begäran och aktiverar din gratis provperiod snart. Den här skärmen öppnar kanalerna så fort den är aktiv.",
  "noAccess.pending.contact": "Hej, jag har begärt en gratis provperiod på IPTViva.",
  "noAccess.used.title": "Gratis provperiod redan använd",
  "noAccess.used.body": "Den här enheten, numret eller e-posten har redan haft en gratis provperiod. Prenumerera för att fortsätta titta.",
  "noAccess.used.contact": "Hej, jag har redan använt min provperiod och vill prenumerera på IPTViva.",
  "noAccess.trialEnded.title": "Din gratis provperiod är slut",
  "noAccess.trialEnded.body": "Vi hoppas att du gillade den. Prenumerera för att fortsätta titta: Standard för en skärm, Premium för två samtidigt.",
  "noAccess.trialEnded.contact": "Hej, min provperiod är slut och jag vill prenumerera på IPTViva.",
  "noAccess.expired.title": "Din prenumeration har gått ut",
  "noAccess.expired.body": "Förnya din prenumeration för att fortsätta titta.",
  "noAccess.expired.contact": "Hej, jag vill förnya min IPTViva-prenumeration.",
  "noAccess.sending": "Skickar…",
  "noAccess.request": "Begär gratis provperiod",
  "noAccess.waiting": "Väntar på aktivering…",
  "noAccess.contactWhatsapp": "Kontakta oss på WhatsApp",
  "noAccess.subscribeWhatsapp": "Prenumerera via WhatsApp",
  "noAccess.loggedInAs": "Inloggad som {name}",
  "common.logOut": "Logga ut",
  "common.cancel": "Avbryt",
  "common.back": "Tillbaka",
  "common.tryAgain": "Försök igen",
  "delete.link": "Radera mitt konto",
  "delete.title": "Radera ditt konto?",
  "delete.body": "Ditt konto och dess data raderas för alltid. Skriv ditt lösenord för att bekräfta.",
  "delete.deleting": "Raderar…",
  "delete.confirm": "Radera kontot",
  "unverified.title": "Det går inte att kontrollera din åtkomst",
  "unavailable.title": "IPTViva är inte tillgängligt",
  "unavailable.device": "Den här enheten kunde inte identifieras. Starta om appen och försök igen.",
  "unavailable.build": "Den här versionen har ingen kontoserver inställd (VITE_ACCOUNT_API).",
  "error.invalid-credentials": "Fel e-post, användarnamn eller lösenord.",
  "error.account-disabled": "Det här kontot är inaktiverat. Kontakta oss.",
  "error.trial-used-on-device": "Den här enheten har redan haft en gratis provperiod. Logga in med ett betalt konto eller kontakta oss för att prenumerera.",
  "error.trial-bound-to-other-device": "Din provperiod används redan på din andra enhet. Prenumerera för att titta på fler enheter.",
  "error.device-limit": "Det här kontot används redan på alla enheter som abonnemanget tillåter. Kontakta supporten för att använda det på en ny.",
  "error.unsupported-device": "Den här enheten stöds inte.",
  "error.rate-limited": "För många försök. Vänta en stund och försök igen.",
  "error.session-ended": "Din session har avslutats. Logga in igen.",
  "error.invalid-email": "Skriv en giltig e-postadress.",
  "error.disposable-email": "Engångsadresser godtas inte. Använd din vanliga e-post.",
  "error.invalid-phone": "Skriv ditt WhatsApp-nummer med landsnummer.",
  "error.weak-password": "Välj ett starkare lösenord: minst 8 tecken, med versal, gemen och en siffra.",
  "error.missing-name": "Skriv ditt namn.",
  "error.email-taken": "Det finns redan ett konto med den här e-posten. Logga in.",
  "error.wrong-password": "Fel lösenord.",
  "error.invalid-code": "Koden är fel eller har gått ut. Kolla e-posten eller begär en ny.",
  "error.code-too-soon": "Vi skickade nyss en kod. Vänta en minut innan du begär en ny.",
  "error.not-active": "Ditt konto har inget aktivt abonnemang.",
  "error.email-unavailable": "Återställning via e-post är inte tillgänglig än. Skriv till oss på WhatsApp så skickar vi ett nytt lösenord.",
  "error.invalid-input": "Välj minst ett språk.",
  "error.server-error": "Något gick fel. Försök igen.",
  "error.offline": "Kan inte nå servern. Kontrollera din internetanslutning.",
  "error.not-configured": "Kontoservern är inte inställd i den här versionen.",
  "common.close": "Stäng",
  "common.dismiss": "Dölj",
  "common.loading": "Laddar…",
  "nav.main": "Huvudmeny",
  "nav.home": "Hem",
  "nav.live": "Live-tv",
  "nav.movies": "Filmer",
  "nav.series": "Serier",
  "nav.search": "Sök",
  "nav.account": "Konto",
  "kind.live": "Live",
  "kind.movie": "Film",
  "kind.series": "Serie",
  "tile.sports": "Livesport",
  "tile.movies": "Filmer",
  "tile.series": "Serier",
  "tile.kids": "Barn",
  "tile.music": "Musik",
  "tile.news": "Nyheter",
  "tile.uhd": "4K UHD",
  "tile.docs": "Dokumentärer",
  "tile.football": "Fotboll",
  "tile.cinema": "Bio",
  "tile.cartoons": "Tecknat",
  "tile.concerts": "Konserter",
  "sync.connecting": "Ansluter",
  "sync.downloading": "Laddar ner listan",
  "sync.live": "Laddar livekanaler",
  "sync.movie": "Laddar filmer",
  "sync.series": "Laddar serier",
  "sync.saving": "Sparar",
  "sync.starting": "Startar",
  "sync.items": "{count} objekt",
  "sync.of": "{done} av {total}",
  "sync.adding": "Laddar {name}",
  "sync.updating": "Uppdaterar {name}",
  "sync.importing": "Importerar {name}",
  "sync.busy": "Kanallistan uppdateras fortfarande. Vänta tills den är klar.",
  "errors.refused": "Leverantören nekade begäran. Kontrollera att kontot är aktivt och inte över sin anslutningsgräns.",
  "errors.notFound": "Adressen finns inte på servern.",
  "errors.serverProblem": "Leverantörens server rapporterade ett problem. Se till att ingen annan enhet använder kontot, vänta en minut och försök igen.",
  "errors.network": "Kan inte nå servern. Kontrollera din internetanslutning.",
  "errors.timeout": "Servern tog för lång tid på sig. Försök igen senare.",
  "errors.http": "Servern returnerade ett fel.",
  "errors.bad-credentials": "Fel användarnamn eller lösenord.",
  "errors.account-expired": "Det här kontot har gått ut. Kontakta oss.",
  "errors.account-disabled": "Det här kontot är inaktiverat. Kontakta oss.",
  "errors.empty-playlist": "Listan innehåller inga kanaler eller videor.",
  "errors.parse": "Listan kunde inte läsas.",
  "errors.invalid-input": "Uppgifter saknas eller är ogiltiga.",
  "errors.storage": "Data kunde inte sparas på den här enheten. Frigör utrymme och försök igen.",
  "errors.cancelled": "Avbrutet.",
  "search.all": "Alla",
  "search.placeholder": "Kanaler, filmer, serier",
  "search.tooShort": "Skriv minst {count} tecken.",
  "search.none": "Inga träffar",
  "search.results": "{count} träffar",
  "filter.language": "Språk",
  "filter.allLanguages": "Alla språk",
  "filter.country": "Land",
  "filter.allCountries": "Alla länder",
  "browse.loadingChannels": "Laddar dina kanaler… Om inget visas, öppna Konto och tryck på Ladda kanaler.",
  "browse.source": "Källa",
  "browse.categories": "Kategorier",
  "browse.other": "Övrigt",
  "browse.recent": "Nyligen tillagda",
  "browse.front": "Utvalt",
  "browse.continue": "Fortsätt titta",
  "browse.seeAll": "Visa alla",
  "browse.previous": "Föregående",
  "browse.next": "Nästa",
  "browse.episodes": "Avsnitt",
  "browse.watched": "Nyligen sedda",
  "favorites.title": "Favoriter",
  "favorites.add": "Lägg till {name} i favoriter",
  "favorites.remove": "Ta bort {name} från favoriter",
  "series.continue": "Fortsätt {episode} från {time}",
  "browse.allFiltered": "Alla {filter}",
  "browse.empty.live": "Inga livekanaler här.",
  "browse.empty.movie": "Inga filmer här.",
  "browse.empty.series": "Inga serier här.",
  "browse.unfinished": "{kind} laddades inte klart.",
  "browse.load.live": "Ladda livekanaler",
  "browse.load.movie": "Ladda filmer",
  "browse.load.series": "Ladda serier",
  "browse.loading.live": "Laddar livekanaler…",
  "browse.loading.movie": "Laddar filmer…",
  "browse.loading.series": "Laddar serier…",
  "browse.meanwhile": "Under tiden är {count} livekanaler redo under Live-tv.",
  "series.loading": "Laddar avsnitt…",
  "series.seasons": "Säsonger",
  "account.username": "Användarnamn",
  "account.name": "Namn",
  "account.plan": "Abonnemang",
  "account.freeTrial": "Gratis provperiod",
  "account.screens": "Skärmar samtidigt",
  "account.unlimited": "Obegränsat",
  "account.trialEndsIn": "Provperioden slutar om",
  "account.validUntil": "Giltigt till",
  "account.trialNotStarted": "{length} · startar när du spelar upp något",
  "account.noEnd": "Inget slutdatum",
  "account.content": "Innehåll",
  "account.lastLoad": "Senaste laddning",
  "account.lastLoadDetail": "{total} ({waiting} väntan på servern, {download} nedladdning, {storing} sparande på den här enheten)",
  "account.loading.live": "kanaler laddas…",
  "account.loading.movie": "filmer laddas…",
  "account.loading.series": "serier laddas…",
  "account.count.live": "{count} kanaler",
  "account.count.movie": "{count} filmer",
  "account.count.series": "{count} serier",
  "account.updateChannels": "Uppdatera kanaler",
  "account.loadChannels": "Ladda kanaler",
  "account.subscribe": "Prenumerera",
  "account.renew": "Förnya",
  "account.subscribeMessage": "Hej, jag vill prenumerera på IPTViva.",
  "account.renewMessage": "Hej, jag vill förnya min IPTViva-prenumeration.",
  "account.helpMessage": "Hej, jag behöver hjälp med IPTViva.",
  "account.help": "Hjälp",
  "account.helpText": "En fråga, en ny enhet eller en kanal som inte fungerar? Kontakta oss, vi svarar varje dag.",
  "account.appLanguage": "Appens språk",
  "account.channelLanguages": "Kanalspråk",
  "account.international": "internationellt",
  "account.saveLanguages": "Spara och ladda om min lista",
  "account.languagesSaved": "Sparat. Din kanallista laddas om med de här språken.",
  "account.changeLanguages": "Ändra språk",
  "time.minutes": "{count} min",
  "time.hoursMinutes": "{hours} h {minutes} min",
  "time.days": "{count} dagar",
  "time.hour": "{count} timme",
  "time.hours": "{count} timmar",
  "home.loading": "Laddar dagens matcher…",
  "home.failed": "Dagens matcher kunde inte laddas. Sidan försöker igen varje minut.",
  "home.welcome": "Välkommen",
  "home.noMatches": "Inga stora fotbollsmatcher just nu. De visas här så fort vi hittar kanaler som sänder dem och flyter bra.",
  "home.liveNow": "Live nu",
  "home.laterToday": "Senare i dag",
  "home.otherLeagues": "Övriga",
  "home.favouriteLeague": "Stjärnmärk {league}: visa först",
  "home.unfavouriteLeague": "Ta bort {league} från favoriter",
  "home.browse": "Utforska",
  "home.allChannels": "Alla kanaler",
  "home.anyTime": "När som helst",
  "home.everyEpisode": "Alla avsnitt",
  "home.todaysMatches": "Dagens matcher",
  "home.slideOf": "{position} av {count}",
  "home.previousMatch": "Föregående match",
  "home.nextMatch": "Nästa match",
  "home.football": "Fotboll",
  "home.checking": "Kontrollerar kanaler…",
  "home.channelIn": "{count} kanal på {language}",
  "home.channelsIn": "{count} kanaler på {language}",
  "home.moreOther": "{count} till på andra språk",
  "home.noChannel": "Ingen kanal än",
  "home.atKickoff": "Kanalerna visas vid avspark, när de har kontrollerats",
  "home.channelsAtKickoff": "Kanaler vid avspark",
  "home.tomorrow": "I morgon",
  "home.days": "Dagar",
  "home.comingUp": "Kommande matcher",
  "home.seeDay": "Se {day}",
  "home.channelsOnMatchDay": "Kanaler på matchdagen",
  "home.noMatchToday": "Ingen match i dag, nästa {date}",
  "home.noMatchDay": "Ingen match denna dag, nästa {date}",
  "home.noMatchesDay": "Inga matcher från de stora ligorna denna dag.",
  "home.noSchedule": "Spelschemat för de kommande dagarna är inte tillgängligt än.",
  "home.watchNow": "Titta nu",
  "home.details": "Detaljer",
  "home.today": "I dag",
  "home.inMinutes": "om {count} min",
  "home.inHours": "om {count} h",
  "home.oneChannel": "{count} kanal",
  "home.channels": "{count} kanaler",
  "home.oneLanguage": "{count} språk",
  "home.languages": "{count} språk",
  "home.checkingLong": "Vi kontrollerar kanalerna som sänder matchen. De som fungerar visas här om en minut eller två.",
  "home.atKickoffLong": "Kanalerna visas här vid avspark, när vi har kontrollerat att de flyter bra.",
  "home.expectedOn": "Väntas på {name} · inte kontrollerad än",
  "home.expectedOnMore": "Väntas på {name} +{count} · inte kontrollerad än",
  "home.willBeOn": "Inte kontrollerade än: de här kanalerna går att titta på när vi har kontrollerat att de flyter bra.",
  "home.mightBeOn": "Kanske på {name}",
  "home.mightBeOnMore": "Kanske på {name} +{count}",
  "home.mightHave": "Kan ha matchen: tryck på en för att prova den.",
  "home.mightHaveShort": "Kan ha matchen",
  "home.moreToTry": "Fler kanaler att prova",
  "home.notChecked": "Inte kontrollerad",
  "home.searchMore": "Sök efter fler",
  "home.searchHint": "Inte i listan? Sök efter kanalerna {channels}.",
  "home.searchHintClubs": "Inte i listan? Sök efter lagens klubbkanaler eller kanalen som sänder matchen.",
  "home.commentary": "Kommentatorsspråk",
  "home.playsSmoothly": "Flyter bra",
  "home.mayShowOther": "Kan visa en annan match",
  "home.guessesBefore": "Matchen sänds på en av de numrerade kanalerna, men vi vet inte vilken än. Under matchen hjälper tittarna oss att hitta den.",
  "home.guessesLive": "Matchen sänds på en av de numrerade kanalerna, men vi vet inte vilken än. Prova en: vi frågar dig om matchen visas där.",
  "home.confirmedByViewers": "Bekräftad av tittare",
  "player.matchQuestion": "Visar den här kanalen {match}?",
  "player.matchYes": "Ja",
  "player.matchNo": "Nej",
  "player.matchThanks": "Tack! När tillräckligt många tittare är överens ser alla svaret.",
  "home.notConfirmed": "Inte bekräftad: kan vara en ungdomsmatch",
  "home.watchedNow": "Tittas på nu · startar direkt",
  "clock.live": "LIVE",
  "clock.ht": "HALVTID",
  "clock.break": "Paus",
  "clock.penalties": "Straffar",
  "clock.ft": "SLUT",
  "clock.paused": "Avbruten",
  "player.buffering": "Laddar…",
  "player.reconnecting": "Återansluter…",
  "player.paused": "Pausad",
  "player.pausedByOtherApp": "Pausad av en annan app (ett samtal?). Tryck på Spela upp för att titta live.",
  "player.soundOffByOtherApp": "Ljudet är av medan en annan app (ett samtal?) använder det. Tryck för att slå på det.",
  "player.soundOffShort": "Ljud av (ett samtal?) · tryck för att slå på",
  "player.finished": "Slut",
  "player.connecting": "Ansluter…",
  "player.queueTitle": "Din gratis provperiod startar om",
  "player.queueNext": "Du står näst på tur.",
  "player.queuePosition": "Du är nummer {position} i kön.",
  "player.queueBody": "Alla provplatser är upptagna just nu. Uppspelningen startar av sig själv, så låt den här skärmen vara öppen. Din provtid startar när du får en plats.",
  "player.anyMoment": "När som helst nu…",
  "player.uhdTitle": "4K och 8K stöds inte på den här enheten",
  "player.uhdBody": "Den här enheten kan inte spela upp 4K eller 8K, så titeln är inte tillgänglig här, och katalogen har ingen HD-version av den. Byt till en annan enhet, till exempel en nyare tv, dator eller telefon, för att få hela katalogen.",
  "browse.uhdHidden": "4K- och 8K-titlar är dolda: den här enheten kan inte spela upp dem. Byt till en annan enhet för att få hela katalogen.",
  "browse.uhdPaused": "4K- och 8K-titlar är pausade tills vidare: du ser HD-versionerna. Tv-apparna för LG och Samsung har fortfarande hela katalogen.",
  "player.uhdPausedTitle": "4K och 8K är pausade tills vidare",
  "player.uhdPausedBody": "4K- och 8K-titlar är inte tillgängliga här tills vidare, och den här har ingen HD-version. Försök igen senare, eller använd vår tv-app för LG eller Samsung för hela katalogen.",
  "player.uhdPausedSwitched": "4K är pausat tills vidare: HD-versionen spelas.",
  "player.uhdSwitched": "Den här enheten kan inte spela upp 4K: HD-versionen spelas i stället.",
  "player.renewBody": "Förnya för att fortsätta titta.",
  "player.trialEndedBody": "Vi hoppas att du gillade den. Prenumerera för att fortsätta titta.",
  "player.fullOne": "Visas redan på {count} skärm",
  "player.full": "Visas redan på {count} skärmar",
  "player.fullBodyOne": "Ditt abonnemang tillåter en skärm åt gången. Stoppa den för att titta här.",
  "player.fullBody": "Ditt abonnemang tillåter {count} skärmar samtidigt. Stoppa en för att titta här.",
  "player.stopAndWatch": "Stoppa {device} och titta här",
  "player.replacedTitle": "Stoppad från en annan skärm",
  "player.replacedBody": "Ditt abonnemang tillåter ett begränsat antal skärmar samtidigt, och den här stoppades så att en annan enhet kunde titta. Premium tillåter två skärmar samtidigt.",
  "player.watchHere": "Titta här",
  "player.muted": "Ljud av",
  "player.volumePercent": "Volym {percent} %",
  "player.behindLive": "{time} efter live. Gå till live",
  "player.goLive": "Gå till live",
  "player.prev": "Föreg.",
  "player.next": "Nästa",
  "player.previous": "Föregående",
  "player.previousChannel": "Föregående kanal",
  "player.nextChannel": "Nästa kanal",
  "player.previousEpisode": "Föregående avsnitt",
  "player.nextEpisode": "Nästa avsnitt",
  "player.back10": "10 sekunder bakåt",
  "player.forward10": "10 sekunder framåt",
  "player.play": "Spela",
  "player.pause": "Pausa",
  "player.audio": "Ljud",
  "player.subtitles": "Undertexter",
  "player.info": "Info",
  "player.fullscreen": "Helskärm",
  "player.off": "Av",
  "player.quality": "Kvalitet",
  "player.qualityStandard": "Standard",
  "player.qualityUnplayable": "{quality} kan inte spelas upp på den här enheten; tillbaka till föregående kvalitet.",
  "player.seek": "Position",
  "player.mute": "Stäng av ljud",
  "player.unmute": "Slå på ljud",
  "player.volume": "Volym",
  "player.upNext": "Nästa: {name}",
  "player.playNext": "Nästa avsnitt",
  "player.watchAgain": "Titta igen",
  "playback.network": "Strömmen gick inte att nå. Kontrollera anslutningen eller försök senare.",
  "playback.stalled": "Strömmen slutade skicka video.",
  "playback.no-start": "Strömmen startade inte. Servern kan vara nere eller mycket långsam.",
  "playback.forbidden": "Leverantören nekade den här strömmen. Kontot kan ha nått sin anslutningsgräns.",
  "playback.not-found": "Den här kanalen finns inte längre hos leverantören.",
  "playback.unsupported": "Den här strömmens format stöds inte på den här enheten.",
  "playback.media": "Videon kunde inte avkodas.",
  "stats.title": "Uppspelningsstatistik",
  "stats.engine": "Motor",
  "stats.resolution": "Upplösning",
  "stats.buffered": "Buffert",
  "stats.stalls": "Avbrott",
  "stats.dropped": "Tappade bildrutor",
  "stats.reconnects": "Återanslutningar",
  "stats.sound": "Ljud",
  "stats.converted": "konverterat till AAC",
  "stats.convertedFrom": "konverterat till AAC från {codec}",
  "stats.original": "original",
  "stats.started": "Startade på",
  "stats.problems": "Senaste problem",
  "stats.none": "inga",
};
